import {
  FETCH_DISCLOSURE,
  FETCH_DISCLOSURE_FAILURE,
  FETCH_DISCLOSURE_SUCCESS,
  RESET_ERROR_STATE,
  RESET_REQUEST_STATUS_STATE,
  RESET_STATE,
} from './constants';

export function fetchDisclosureFailure(error) {
  return {
    payload: { error },
    type: FETCH_DISCLOSURE_FAILURE,
  };
}

export function fetchDisclosureSuccess({ disclosure, disclosureName }) {
  return {
    payload: { disclosure, disclosureName },
    type: FETCH_DISCLOSURE_SUCCESS,
  };
}

export function fetchDisclosure({ disclosureName, language }) {
  return {
    payload: { disclosureName, language },
    type: FETCH_DISCLOSURE,
  };
}

export function resetErrorState() {
  return { type: RESET_ERROR_STATE };
}

export function resetRequestStatusState() {
  return { type: RESET_REQUEST_STATUS_STATE };
}

export function resetState() {
  return { type: RESET_STATE };
}
